import { render } from "./DashboardLink.vue?vue&type=template&id=3af1289f&scoped=true"
import script from "./DashboardLink.vue?vue&type=script&lang=js"
export * from "./DashboardLink.vue?vue&type=script&lang=js"

import "./DashboardLink.vue?vue&type=style&index=0&id=3af1289f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af1289f"]])

export default __exports__